import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('#machine-region-mapping-items-table', () => {
  void import('./internal/machine-region-mapping-items-table')
    .then(({ default: Component }) => Component());
});
